import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Grid, Typography, Chip } from '@mui/material';
import DataTable from '../../../sharedModules/dataTable';
import axios from '../../../sharedModules/utils/axios.utils';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const contactColumns = [
  {
    name: 'Location',
    selector: (row: any) => row.db_location,
    sortable: true,
    width: '120px',
  },
  {
    name: 'Vendor ID',
    selector: (row: any) => row.vendor_id,
    sortable: true,
    width: '120px',
  },
  {
    name: 'Contact ID',
    selector: (row: any) => row.vcon_id,
    sortable: true,
    width: '120px',
  },
  {
    name: 'Full Name',
    selector: (row: any) => row.full_name,
    sortable: true,
    grow: 2,
  },
  {
    name: 'Email',
    selector: (row: any) => row.email || 'N/A',
    sortable: true,
    grow: 2,
  },
  {
    name: 'Phone',
    selector: (row: any) => row.phone || 'N/A',
    sortable: true,
    width: '140px',
  },
  {
    name: 'Job Title',
    selector: (row: any) => row.job_title || 'N/A',
    sortable: true,
  },
  {
    name: 'Contact Type',
    selector: (row: any) => row.contact_type || 'N/A',
    sortable: true,
    width: '120px',
  },
  {
    name: 'Primary',
    selector: (row: any) => row.is_primary,
    sortable: true,
    cell: (row: any) => (
      <Chip
        label={row.is_primary === 'Y' ? 'Yes' : 'No'}
        color={row.is_primary === 'Y' ? 'primary' : 'default'}
        size="small"
      />
    ),
    width: '100px',
  },
  {
    name: 'Updated At',
    selector: (row: any) => (row.updated_at ? new Date(row.updated_at).toLocaleString() : 'N/A'),
    sortable: true,
    width: '180px',
  },
];

const VendorContactsListPage: React.FC = () => {
  const [contacts, setContacts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await axios.get<string, any>('/vendors/servman_vendor_contacts');
        setContacts(response?.data || []);
      } catch (error) {
        console.error('Error fetching vendor contacts:', error);
        setError('Failed to load vendor contacts. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchContacts();
  }, []);

  if (loading) {
    return (
      <Box sx={{ width: '100%' }}>
        <Grid container>
          <Grid item xs={12} style={{ marginTop: 20 }}>
            <Typography style={{ fontSize: '20px' }} variant="h3">
              Vendor Management <NavigateNextIcon fontSize="small" style={{ margin: '-4px 4px' }} /> Vendor Contacts
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>Loading contacts...</div>
          </Grid>
        </Grid>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ width: '100%' }}>
        <Grid container>
          <Grid item xs={12} style={{ marginTop: 20 }}>
            <Typography style={{ fontSize: '20px' }} variant="h3">
              Vendor Management <NavigateNextIcon fontSize="small" style={{ margin: '-4px 4px' }} /> Vendor Contacts
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 20 }}>
            <div style={{ color: 'red', textAlign: 'center', padding: '50px' }}>{error}</div>
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <Grid container>
      <Grid item xs={12} style={{ marginTop: 20 }}>
        <Grid container justifyContent="space-between">
          <Grid item style={{ marginBottom: 3 }}>
            <Typography style={{ display: 'inline-block', fontSize: '20px' }} variant="h3">
              Vendor Management
            </Typography>
            <NavigateNextIcon
              fontSize="small"
              style={{
                color: '#3d5a80 !important',
                fontWeight: 700,
                fontSize: '20px !important',
                margin: '-4px 4px',
              }}
            />
            <Typography style={{ display: 'inline-block', fontSize: '20px' }} variant="h3">
              Vendor Contacts
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} style={{ marginTop: 20 }}>
        <Card>
          <CardContent>
            <Box sx={{ mt: 3 }}>
              <DataTable
                title=""
                columns={contactColumns}
                data={contacts}
                pagination
                paginationPerPage={25}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                highlightOnHover
                pointerOnHover
                responsive
                dense
                noHeader
              />
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default VendorContactsListPage;
